import { Link } from "react-router-dom";
import { Home, ChevronRight } from "lucide-react";

/**
 * Small back-to-home / section breadcrumb to drop near the top of every subpage.
 * Always shows on dark backgrounds; pinned-left, low-emphasis but tappable.
 */
export default function Breadcrumb({ section }) {
    return (
        <nav
            aria-label="Breadcrumb"
            data-testid="breadcrumb"
            className="lbp-container pt-5 sm:pt-6"
        >
            <div className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-zinc-400">
                <Link
                    to="/"
                    data-testid="breadcrumb-home-link"
                    className="inline-flex items-center gap-1.5 hover:text-red-500 transition-colors font-semibold"
                >
                    <Home className="w-3.5 h-3.5" />
                    Home
                </Link>
                {section ? (
                    <>
                        <ChevronRight className="w-3.5 h-3.5 text-zinc-600" />
                        <span className="text-zinc-500">{section}</span>
                    </>
                ) : null}
            </div>
        </nav>
    );
}
